import { Badge } from '@mantine/core'
import { IconShield } from '@tabler/icons-react'

export type RiskLevel = 'low' | 'medium' | 'high' | 'very_high'

const CONFIG: Record<RiskLevel, { color: string; label: string }> = {
  low:      { color: 'gray',   label: 'Baixo' },
  medium:   { color: 'yellow', label: 'Médio' },
  high:     { color: 'orange', label: 'Alto' },
  very_high:{ color: 'red',    label: 'Muito Alto' },
}

export function GmudRiskBadge({ risk, size = 'sm' }: { risk: RiskLevel | string; size?: 'xs' | 'sm' }) {
  const cfg = CONFIG[risk as RiskLevel] ?? { color: 'gray', label: risk }
  return (
    <Badge color={cfg.color} variant="light" size={size} leftSection={<IconShield size={10} />} aria-label={`Risco: ${cfg.label}`}>
      {cfg.label}
    </Badge>
  )
}
